// extracted by mini-css-extract-plugin
export default {"promptSuggestions":"VZ3K04YSswEDBtnUQY6t"};